<template>
    <div>
        <page-header title="لیست محصولات" create-url="/products/create"></page-header>

        <search-filter :filters="filters" @search="search"></search-filter>

        <table-with-pagination v-if="products"
                               :items="products"
                               :headers="headers"
                               :default-page="parseInt($route.query.page ?? '1')"
                               @fetchPage="getProducts"
                               @delete="deleteProduct"
                               @statusChanged="statusChanged"
                               :actions="actions"
        ></table-with-pagination>
    </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import TableWithPagination from "@/components/General/TableWithPagination";
import SearchFilter from "@/components/General/SearchFilter.vue";

export default {
    name: "ProductList",

    components: {SearchFilter, TableWithPagination, PageHeader},

    data() {
        return {
            headers: [
                {text: 'شناسه', value: 'id', align: 'center'},
                {text: 'نام فارسی', value: 'fa_name', align: 'center'},
                {text: 'نام انگلیسی', value: 'en_name', align: 'center'},
                {text: 'کد محصول', value: 'article_number', align: 'center'},
                {text: 'عکس', value: 'image_url', align: 'center'},
                {text: 'دسته بندی', value: 'category', align: 'center'},
                {text: 'وضعیت', value: 'status', align: 'center'},
                {text: 'تعداد بازدید', value: 'visits', align: 'center'},
                {text: 'قیمت', value: 'price', align: 'center'},
                {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
                {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
                {text: 'عملیات', value: 'actions', align: 'center'},
            ],

            products: null,

            actions: [
                {
                    icon: 'mdi-pencil',
                    color: 'warning',
                    route_name: 'update-product',
                    route_param: 'fa_slug'
                },
                {
                    icon: 'mdi-delete',
                    color: 'error',
                    emit: 'delete',
                    identifier: 'fa_slug',
                    delete_confirm: true,
                }
            ],

            filters: [],
            searchValues: '',
            allCategories: []
        }
    },

    mounted() {
        this.getProducts(parseInt(this.$route.query.page ?? "1"))
        this.getAllCategories()
    },

    methods: {
        search(values) {
            this.$store.dispatch("objectParametersToString", values).then((result) => {
                this.searchValues = result
                this.getProducts()
            })
        },

        getProducts(page = 1) {
            this.$store.dispatch("getPaginatedProducts", page + this.searchValues)
                .then((res) => {
                    this.products = res.data
                })
        },

        getAllCategories() {
            this.$store.dispatch("getAllCategories")
                .then((res) => {
                    this.allCategories = res.data
                    this.fillFilters()
                })
        },

        fillFilters() {
            this.filters = [
                {
                    type: 'text',
                    name: 'needle',
                    label: 'جستجو',
                },
                {
                    type: 'text',
                    name: 'article_number',
                    label: 'کد محصول',
                },
                {
                    type: 'select',
                    name: 'category_id',
                    label: 'دسته بندی',
                    select_text: 'fa_name',
                    select_value: 'id',
                    select_items: this.allCategories,
                },
                {
                    type: 'select',
                    name: 'status',
                    label: 'وضعیت',
                    select_text: 'text',
                    select_value: 'value',
                    select_items: [
                        {text: 'فعال', value: '1'},
                        {text: 'غیر فعال', value: '0'},
                    ],
                },
            ]
        },

        deleteProduct(slug) {
            this.$store.dispatch("deleteProduct", slug)
                .then(() => {
                    this.getProducts(this.products.pagination.current_page)
                })
        },

        statusChanged(item) {
            this.$store.dispatch("toggleProductStatus", item.fa_slug)
                .then(() => {
                    this.getProducts(this.products.pagination.current_page)
                })
        }
    }
}
</script>

<style scoped>

</style>